module.exports = ".forgetPasswordButton{\n    background:none;\n    border:none;\n    color: black;\n    margin:0;\n    padding-top: 5px;\n}\n.fpBackButton {\n    border: none;\n    outline: 0;\n    display: inline-block;\n    padding: 8px;\n    color: white;\n    background-color: #000;\n    text-align: center;\n    cursor: pointer;\n    width: 100%;\n    font-size: 18px;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/signin/signin.component.css
// module id = ./src/app/signin/signin.component.css
// module chunks = main